import { ensureFeatures, featuresState } from 'stores/features';
import { AppRoute } from 'framework/components/navigation/Navigation.interfaces';
import { featureFlag } from 'featureFlag';
import { homeRoutes } from './home';
import { cmsRoutes } from './contentmanagement/routes';
import { slotManagementeRoutes } from './slotManagement/routes';
import { storesRoutes } from './stores/routes';
import { productsRoutes } from './products/routes';
import { searchRoutes } from './searchadmin/routes';
import { merchandisingRoutes } from './merchandising/routes';
import { promotionsRoutes } from './promotions/routes';
import { orderManagementRoutes } from './orderManagement/routes';
import { crmRoutes } from './crm/routes';
import { orderFulfillmentRoutes } from './orderFulfillment/routes';
import { siteadminRoutes } from './siteadmin/routes';
import { reportRoutes } from './reports/routes';
import { siteSettingsRoutes } from './siteSettings/routes';
import { useGrowthBook } from '@growthbook/growthbook-react';

export const useAppRoutes = () => {
  const gb = useGrowthBook();
  const allRoutes: AppRoute[] = [
    ...homeRoutes,
    ...cmsRoutes,
    ...slotManagementeRoutes,
    ...storesRoutes,
    ...productsRoutes,
    ...searchRoutes,
    ...merchandisingRoutes,
    ...promotionsRoutes,
    ...orderManagementRoutes,
    ...crmRoutes,
    ...orderFulfillmentRoutes,
    ...siteadminRoutes,
    ...reportRoutes,
    ...siteSettingsRoutes,
  ];

  const localRoutes: AppRoute[] = allRoutes.filter((appRoute) => {
    const { requiredFeatures, alwaysShowInDev, requiredGrowthbookFeatures, disabledByGrowthbookFeatures } = appRoute;

    // Must precede the early return below, otherwise a route carrying only a disable flag is always shown
    if (disabledByGrowthbookFeatures?.some((flag) => gb?.isOn?.(flag))) {
      return false;
    }

    // If neither app features nor growthbook features are required, show the route
    const hasRequiredFeatures = Array.isArray(requiredFeatures) && requiredFeatures.length > 0;
    const hasGbRequirements = Array.isArray(requiredGrowthbookFeatures) && requiredGrowthbookFeatures.length > 0;
    if (!hasRequiredFeatures && !hasGbRequirements) {
      return true;
    }

    // If route has required app features, check them
    const featuresOk = hasRequiredFeatures
      ? featureFlag({
          dev: () => alwaysShowInDev ?? ensureFeatures(requiredFeatures),
          prod: () => ensureFeatures(requiredFeatures),
        })
      : true;

    const growthbookFeaturesOk = hasGbRequirements
      ? requiredGrowthbookFeatures.every((flag) => gb?.isOn?.(flag))
      : true;
    return featuresOk && growthbookFeaturesOk;
  });

  return { localRoutes, isLoading: featuresState.isLoading };
};
